import styled from 'styled-components';

import { PaletteColor } from '@utils/types';

export const StyledListingItemTimeZone = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 5px;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 3px;
  }
`;

export const TimeZoneLocationLabel = styled.span<{ textColor: PaletteColor }>`
  line-height: 150%;
  font-size: 12px;
  color: ${({ theme, textColor }) => theme.palette[textColor]};
  opacity: ${({ textColor }) => (textColor === 'black' ? '0.6' : '1')};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 10px;
  }
`;

export const DistanceFromCenterWrapper = styled.div`
  b {
    font-weight: 600;
  }
`;
